import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Divider,
  Tooltip,
  TextField,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { UserDataContext } from "../Contexts/UserDataContext";
import { InvoiceDataContext } from "../Contexts/InvoiceDataContext";
import { roles, invoiceStatuses } from "../Mappings";
import ChargeSummaryTable from "./ChargeSummaryTable";
import AccountingSummaryTable from "./AccountingSummaryTable";
import { AppStateContext } from "../Contexts/AppStateContext";

const axios = require("axios");

// this stupid component always causes problems.
const ApproveRejectInvoice = ({
  truckId,
  week,
  invoiceId,
  invoice,
  ...others
}) => {
  const { userData, setUserData } = useContext(UserDataContext);
  const { invoiceData, setInvoiceData, updateInvoice } =
    useContext(InvoiceDataContext);
  // const invoice = invoiceData[invoiceData.findIndex((invoice) => invoice.id === invoiceId)];
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    values: { comments: "" },
    valid: { comments: false },
  });
  const { scrollToPosition, setScrollPosition } = useContext(AppStateContext);

  const sendApproveRequest = async () => {
    let endPoint = "";
    if (userData.roleId === roles.tollAdmin) {
      endPoint = "adminapprove";
    } else if (userData.roleId === roles.tollManager) {
      endPoint = "managerapprove";
    }
    try {
      setLoading(true);
      const res = await axios({
        method: "POST",
        url: `/invoices/${endPoint}/${invoiceId}/${formData.values.comments}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userData.token}`,
        },
      });
      setLoading(false);
      let newStatus;
      if (userData.roleId === roles.tollAdmin) {
        newStatus = invoiceStatuses.adminApproved;
      } else if (userData.roleId === roles.tollManager) {
        newStatus = invoiceStatuses.managerApproved;
      }
      setOpen(false);
      updateInvoice(invoice.id, {
        ...invoice,
        approvalState: newStatus,
        [userData.roleId === roles.tollAdmin
          ? "adminComments"
          : "managerComments"]: formData.values.comments,
      });

      // userData.invoiceStatuses[truckId][week] = res.data;
      // setUserData({ ...userData }); // force fetch statuses again

      setUserData({
        ...userData,
        invoiceStatuses: {
          ...userData.invoiceStatuses,
          [truckId]: {
            ...userData.invoiceStatuses?.[truckId],
            [week]: res.data,
          },
        },
      }); // force fetch statuses again
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const sendRejectRequest = async () => {
    try {
      setLoading(true);
      const res = await axios({
        method: "POST",
        url: `/invoices/reject/${invoiceId}/${formData.values.comments}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userData.token}`,
        },
      });
      setLoading(false);
      setOpen(false);
      updateInvoice(invoice.id, {
        ...invoice,
        approvalState: invoiceStatuses.rejected,
        [userData.roleId === roles.tollAdmin
          ? "adminComments"
          : "managerComments"]: formData.values.comments,
      });

      setUserData({
        ...userData,
        invoiceStatuses: {
          ...userData.invoiceStatuses,
          [truckId]: {
            ...userData.invoiceStatuses[truckId],
            [week]: res.data,
          },
        },
      }); // force fetch statuses again
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const sendPdfRequest = async () => {
    // window.open("/invoices/GeneratePdfInvoice/318-20200524"); // this opens properly

    try {
      const res = await axios({
        method: "GET",
        url: `/files/GetInvoicePDF/${invoice.id}`,
        headers: {
          Authorization: `bearer ${userData.token}`,
          "Content-Type": "application/pdf",
        },
      });

      const buf = Buffer.from(res.data.data, "base64");
      const blob = new Blob([buf], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url); // this opens a blank pdf

      setTimeout(function () {
        window.URL.revokeObjectURL(url);
      }, 600000); //garbage collect after 10mins 

    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event) => {
    setFormData({
      values: { ...formData.values, [event.target.name]: event.target.value },
      valid: {
        ...formData.valid,
        [event.target.name]: event.target.value !== "",
      },
    });
  };

  // useEffect(() => {
  //   console.log(invoice);
  //   // fdsfd
  // }, []);

  return (
    <>
      <Tooltip title="Approve or Reject">
        <IconButton
          onClick={() => {
            setScrollPosition();
            setOpen(true);
          }}
        >
          <VisibilityIcon />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Approve or Reject Invoice</DialogTitle>
        <Divider />
        <DialogContent>
          <ChargeSummaryTable invoiceId={invoice.id} />
          {/* </DialogContent>
        <Divider />
        <DialogContent> */}
          <AccountingSummaryTable invoiceId={invoice.id} />
        </DialogContent>
        <Divider />
        <DialogContent>
          {/* <Typography>Admin comments: {invoice.adminComments}</Typography> */}
          {/* <Typography>Manager comments: {invoice.managerComments}</Typography> */}
          <TextField
            disabled
            fullWidth
            label="Admin Comments"
            InputLabelProps={{ shrink: true }}
            value={invoice.adminComments}
          />
          <TextField
            disabled
            fullWidth
            label="Manager Comments"
            InputLabelProps={{ shrink: true }}
            value={invoice.managerComments}
          />
        </DialogContent>
        {userData.roleId === roles.tollAdmin && (
          <DialogContent>
            <TextField
              label="Approver Comments"
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              disabled={
                loading || invoice.approvalState !== invoiceStatuses.submitted
              }
              fullWidth
            />
          </DialogContent>
        )}
        {userData.roleId === roles.tollManager && (
          <DialogContent>
            <TextField
              label="Approver Comments"
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              disabled={
                loading ||
                invoice.approvalState !== invoiceStatuses.adminApproved
              }
              fullWidth
            />
          </DialogContent>
        )}
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              const url = `/${userData.userName}/trucks/${truckId}/weeks/${week}`;
              console.log(url);
              history.push(url);
            }}
            disabled={loading || week > 4}
          >
            View DPC data
          </Button>

          {userData.roleId === roles.tollAdmin && (
            <>
              <Button
                variant="contained"
                color="secondary"
                disabled={
                  loading ||
                  !formData.valid.comments ||
                  invoice.approvalState !== invoiceStatuses.submitted
                }
                onClick={() => sendRejectRequest()}
              >
                Reject
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={
                  loading ||
                  !formData.valid.comments ||
                  invoice.approvalState !== invoiceStatuses.submitted
                }
                onClick={() => sendApproveRequest()}
              >
                Approve
              </Button>
            </>
          )}

          {userData.roleId === roles.tollManager && (
            <>
              <Button
                variant="contained"
                color="secondary"
                disabled={
                  loading ||
                  !formData.valid.comments ||
                  invoice.approvalState !== invoiceStatuses.adminApproved
                }
                onClick={() => sendRejectRequest()}
              >
                Reject
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={
                  loading ||
                  !formData.valid.comments ||
                  invoice.approvalState !== invoiceStatuses.adminApproved
                }
                onClick={() => sendApproveRequest()}
              >
                Approve
              </Button>
            </>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={sendPdfRequest}
            disabled={invoice.approvalState !== invoiceStatuses.managerApproved}
          >
            view pdf
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApproveRejectInvoice;

ApproveRejectInvoice.propTypes = {
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  invoiceId: PropTypes.string.isRequired,
};
